import {
  OffersColumnTypes,
  RequestsColumnTypes,
} from 'src/app/dashboard/components/overview/models/overview.model';

export const displayOfferColumns = [
  OffersColumnTypes.manureCategory,
  OffersColumnTypes.manureType,
  OffersColumnTypes.amountInTons,
  OffersColumnTypes.nKgPerTon,
  OffersColumnTypes.maxNitrogen,
  OffersColumnTypes.pKgPerTon,
  OffersColumnTypes.maxPhosphate,
  OffersColumnTypes.kKgPerTon,
  OffersColumnTypes.isHomogeneous,
  OffersColumnTypes.maxDistance,
  OffersColumnTypes.desiredDeliveryPeriod,
  OffersColumnTypes.paymentType,
  OffersColumnTypes.pricePerTon,
  OffersColumnTypes.totalPrice,
  OffersColumnTypes.status,
] as const;

export const displayRequestColumns = [
  RequestsColumnTypes.manureCategory,
  RequestsColumnTypes.manureType,
  RequestsColumnTypes.amountInTons,
  RequestsColumnTypes.nKgPerTon,
  RequestsColumnTypes.maxNitrogen,
  RequestsColumnTypes.pKgPerTon,
  RequestsColumnTypes.maxPhosphate,
  RequestsColumnTypes.kKgPerTon,
  RequestsColumnTypes.isHomogeneous,
  RequestsColumnTypes.distance,
  RequestsColumnTypes.desiredDeliveryPeriod,
  RequestsColumnTypes.paymentType,
  RequestsColumnTypes.pricePerTon,
  RequestsColumnTypes.totalPrice,
  RequestsColumnTypes.status,
] as const;
